import { jsx as _jsx } from "react/jsx-runtime";
import translate from "../../../i18n/translate";
const Loading = ({ message }) => {
    return (_jsx("div", Object.assign({ className: "cohort-loader" }, { children: _jsx("div", Object.assign({ className: "content-loader content", role: "alert" }, { children: translate(message !== null && message !== void 0 ? message : "global.loading") })) })));
};
export default Loading;
